import {
  Box,
  Button,
  FormControl,
  Image,
  Input,
  Link,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Select,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import React, { useState } from "react";

import { FaUserEdit } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { AiTwotoneEye } from "react-icons/ai";
import { AiTwotoneEyeInvisible } from "react-icons/ai";
import { MdCall } from "react-icons/md";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {Link as MyLink} from "react-router-dom"

const Step2otp = () => {
  function BackdropExample() {
    const [hidden, setHidden] = useState(true);
    const [form, setForm] = useState({ category: "medicalTreatment" });

    const onChange = (e) => {
      let { type, name, value } = e.target;
      console.log(type, name, value);
      setForm({
        ...form,
        [name]: value,
      });
    };

    useEffect(() => {
      console.log(form);
    }, [form]);

    const OverlayOne = () => (
      <ModalOverlay
        bg="#3d3d3d"
        backdropFilter="blur(10px) hue-rotate(90deg)"
      />
    );

    const { isOpen, onOpen, onClose } = useDisclosure();
    const [overlay, setOverlay] = React.useState(<OverlayOne />);
    useEffect(() => {
      onOpen();
    }, []);
    const navigate=useNavigate();

const handleClose=()=>{
  navigate("/",{replace:true});
    }
    const handleNext = () => {
      navigate("/step3",{replace:true})
    }

    return (
      <>
        {/* <Button
          onClick={() => {
            setOverlay(<OverlayOne />);
            onOpen();
          }}
        >
          Use Overlay one
        </Button> */}
        <Modal
          closeOnOverlayClick={false}
          isCentered
          isOpen={isOpen}
          onClose={onClose}
        >
          {overlay}
          <ModalContent>
            {/* ---------------- */}
            <ModalHeader
              style={{
                textAlign: "center",
                fontSize: "18px",
                fontWeight: "bold",
              }}
            >
              Start your fundraiser
            </ModalHeader>
            <ModalCloseButton onClick={handleClose}/>
            <hr />
            <ModalBody pb={6} pl={5} pr={20}>
              <Box
                style={{
                  width: "400px",
                  height: "50px",
                  margin: "auto",
                  display: "flex",
                  justifyContent: "space-around",
                  margin: "0px 20px",
                  backgroundColor: "#f5f5f5",
                  paddingTop: "5px",
                  borderRadius: "25px",
                  marginLeft: "7px",
                }}
              >
                <Box
                  style={{
                    fontSize: "14px",
                    marginRight: "10px",
                    width: "170px",
                    marginTop: "8px",
                    marginLeft: "10px",
                    fontWeight: "bold",
                  }}
                >
                  Purpose of raising funds
                </Box>
                <Box style={{ marginRight: "0px", marginLeft: "-10px" }}>
                  <Select
                    variant="flushed"
                    name="category"
                    value={form.category}
                    onChange={onChange}
                    id=""
                    style={{
                      width: "150px",
                      fontSize: "13px",
                      borderBottom: "1px solid black",
                    }}
                  >
                    <option
                      style={{ fontSize: "13px" }}
                      value="medicalTreatment"
                    >
                      Medical Treatment
                    </option>
                    <option style={{ fontSize: "13px" }} value="ngo/charity">
                      NGO / Charity
                    </option>
                    <option style={{ fontSize: "13px" }} value="otherCause">
                      Other Cause
                    </option>
                  </Select>
                </Box>
              </Box>

              <FormControl mt={2}>
                <Input
                  onChange={onChange}
                  variant="flushed"
                  placeholder="Mobile"
                  ml={6}
                  type="number"
                  pl={50}
                />
                <MdCall
                  color="#ccc"
                  style={{
                    position: "relative",
                    left: "350px",
                    top: "-25px",
                    height: "20px",
                    width: "20px",
                  }}
                />
                <Image
                  style={{
                    width: "20px",
                    height: "14px",
                    position: "absolute",
                    top: "10px",
                    left: "30px",
                  }}
                  src="https://cdn.britannica.com/97/1597-004-05816F4E/Flag-India.jpg"
                />
              </FormControl>

              <FormControl mt={2}>
                <Input
                  onChange={onChange}
                  variant="flushed"
                  placeholder="Otp"
                  ml={6}
                  mt={-5}
                  name="otp"
                />
              </FormControl>

              <Box
                style={{
                  textAlign: "center",
                  marginTop: "20px",
                  marginLeft: "55px",
                }}
              >
                Already have an account?{" "}
                <MyLink style={{ color: "#52c0bd" }} to="/login">Login</MyLink>
              </Box>
            </ModalBody>

            <ModalFooter>
              <Button
                colorScheme="blue"
                w="full"
                margin={0}
                p={0}
                style={{
                  position: "absolute",
                  width: "448px",
                  left: "0px",
                  borderTopLeftRadius: "0px",
                  borderTopRightRadius: "0px",
                  backgroundColor: "#52c0bd",
                  fontWeight: "bold",
                  fontSize: "14px",
                }}
                onClick={handleNext}
              >
                Next
              </Button>
              <Box
                style={{
                  position: "absolute",
                  top: "510px",
                  left: "120px",
                  color: "white",
                  fontWeight: "bold",
                }}
              >
                Are you an NGO?{" "}
                <Link style={{ color: "#52c0bd" }}>Apply here</Link>
              </Box>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </>
    );
  }
  return (
    <div>
      <BackdropExample />
    </div>
  );
};

export default Step2otp;
